import { graphql, useStaticQuery } from 'gatsby'
import { useIntl } from 'react-intl'

import { strapiPageToLinkTo } from '@utils/cms/pageLink'
import useStaticContentful from './useStaticContentful'

const useStrapiPageJobOffers = (): [
  MCDC.Contentful.IPageGeneric | undefined,
  MCDC.Contentful.IPageGeneric[]
] => {
  const { locale } = useIntl()
  const { meta } = useStaticContentful()
  const { data } = useStaticQuery(
    graphql`
      query StrapiPageJobOffersQuery {
        data: allStrapiPageGeneric {
          nodes {
            id
            slug
            path
            label
            metaType
            titleInternal
          }
        }
      }
    `
  )

  const nodes = data.nodes || []

  const toPage = (entry: {
    id: string
    slug?: string
    path?: string
    label?: string
    metaType?: string
    titleInternal?: string
  }): MCDC.Contentful.IPageGeneric =>
    ({
      id: entry.id,
      node_locale: locale,
      metaType: entry.metaType,
      label: entry.label,
      fields: {
        linkTo: strapiPageToLinkTo(entry, meta),
      },
    }) as MCDC.Contentful.IPageGeneric

  const offersEntry = nodes.find(
    (entry: { metaType?: string }) => entry.metaType === 'offers'
  )

  return [
    offersEntry ? toPage(offersEntry) : undefined,
    nodes.map(toPage),
  ]
}

export default useStrapiPageJobOffers
